const AboutMe = () => {
  return (
    <section>
      <h2 className="title-font pink-text h2-tag">About Me</h2>
      <p className="white-text p-tag">
        I am a student of graphic designer at Arena Multimedia,I am a beginner
        graphic designer who can make vector art and work on InDesign.
        I am a beginner graphic designer who can make vector art and work on InDesign
      </p>
    </section>
  );
};
export default AboutMe;
